import { styled } from '@mui/material';

// The text uses primary.dark: primary.main on white is below the AA contrast ratio for 12px text
export const StyledUtahBadge = styled('span')(({ theme }) => ({
  ...theme.typography.caption,
  display: 'inline-flex',
  alignItems: 'center',
  gap: theme.spacing(1),
  width: 'fit-content',
  height: '24px',
  padding: `0 ${theme.spacing(2)}`,
  border: `1px solid ${theme.palette.primary.main}`,
  borderRadius: '9999px',
  color: theme.palette.primary.dark,
  fontWeight: 600,
  whiteSpace: 'nowrap',
}));

export const StyledUtahBadgeLabel = styled('span')({
  display: 'block',
  lineHeight: 1,
});

export const StyledLocationIcon = styled('span')({
  display: 'inline-flex',
  flexShrink: 0,

  '& > svg': {
    width: '16px',
    height: '16px',
  },

  '& path': {
    fill: 'currentColor',
  },
});
